export const fieldContainerHeight: number = 32
export const defaultQueryMinLength: number = 3
